/*Sidebar*/
/*eslint-disable */
import i_vias from './../UI/icons/Sidebar/Vias.svg'
import i_vias2 from './../UI/icons/Sidebar/Vias2.svg'
import i_beneficios from './../UI/icons/Sidebar/Puntos-interes.svg'
import i_beneficios2 from './../UI/icons/Sidebar/Puntos-interes2.svg'
import i_amenidades from './../UI/icons/Sidebar/Amenidades.svg'
import i_amenidades2 from './../UI/icons/Sidebar/Amenidades2.svg'
import i_etapas from './../UI/icons/Sidebar/Proyecto.svg'
import i_etapas2 from './../UI/icons/Sidebar/Proyecto2.svg'
import i_vistas from './../UI/icons/Sidebar/vistas2.svg'
import i_vistas2 from './../UI/icons/Sidebar/vistas.svg'

import i_renders from './../UI/icons/Galerias/renders.svg'
import i_recor from './../UI/icons/Galerias/360.svg'
import i_back from './../UI/icons/back-btn.svg'

/*Amenities*/

import i_guarderia from './../UI/icons/Amenities/GuarderiaMascotas.svg'
import i_guarderia2 from './../UI/icons/Amenities/GuarderiaMascotas_White.svg'
import i_cancha from './../UI/icons/Amenities/Cancha.svg'
import i_cancha2 from './../UI/icons/Amenities/Cancha_White.svg'
import i_piscina from './../UI/icons/Amenities/Piscina.svg'
import i_piscina2 from './../UI/icons/Amenities/Piscina_White.svg'
import i_chimenea from './../UI/icons/Amenities/Firepit.svg'
import i_chimenea2 from './../UI/icons/Amenities/Firepit_White.svg'
import i_juegosInfantil from './../UI/icons/Amenities/JuegosInfantiles.svg'
import i_juegosInfantil2 from './../UI/icons/Amenities/JuegosInfantiles_White.svg'
import i_zonaLibre from './../UI/icons/Amenities/PetPark.svg'
import i_zonaLibre2 from './../UI/icons/Amenities/PetPark_White.svg'
import i_parqueadero from './../UI/icons/Amenities/Estancia deportiva.svg'
import i_parqueadero2 from './../UI/icons/Amenities/Estancia deportiva_White.svg'
import i_triciclo from './../UI/icons/Amenities/Triciclos.svg'
import i_triciclo2 from './../UI/icons/Amenities/Triciclos_white.svg'
import i_salonNinos from './../UI/icons/Amenities/SalonNinhos.svg'
import i_salonNinos2 from './../UI/icons/Amenities/SalonNinhos_white.svg'
import i_salonNinas from './../UI/icons/Amenities/SalonNinhas.svg'
import i_salonNinas2 from './../UI/icons/Amenities/SalonNinhas_white.svg'
import i_playground from './../UI/icons/Amenities/Playground.svg'
import i_playground2 from './../UI/icons/Amenities/Playground_White.svg'
import i_babyGym from './../UI/icons/Amenities/BabyGym.svg'
import i_babyGym2 from './../UI/icons/Amenities/BabyGym_White.svg'
import i_terraza from './../UI/icons/Amenities/Terraza ludica.svg'
import i_terraza2 from './../UI/icons/Amenities/Terraza ludica_White.svg'
import i_cinema from './../UI/icons/Amenities/Cinema.svg'
import i_cinema2 from './../UI/icons/Amenities/Cinema_White.svg'
import i_bbq from './../UI/icons/Amenities/BBQ.svg'
import i_bbq2 from './../UI/icons/Amenities/BBQ_white.svg'
import i_yoga from './../UI/icons/Amenities/SalonYoga.svg'
import i_yoga2 from './../UI/icons/Amenities/SalonYoga_white.svg'
import i_salonJuegos from './../UI/icons/Amenities/Salon de Juegos.svg'
import i_salonJuegos2 from './../UI/icons/Amenities/Salon de Juegos_white.svg'
import i_club from './../UI/icons/Amenities/ClubHouse.svg'
import i_club2 from './../UI/icons/Amenities/ClubHouse_White.svg'
import i_laundry from './../UI/icons/Amenities/Laundry.svg'
import i_laundry2 from './../UI/icons/Amenities/Laundry_White.svg'
import i_coworking from './../UI/icons/Amenities/Coworking.svg'
import i_coworking2 from './../UI/icons/Amenities/Coworking_White.svg'
import i_observatorio from './../UI/icons/Amenities/Observatorio.svg'
import i_observatorio2 from './../UI/icons/Amenities/Observatorio_white.svg'
import i_herbario from './../UI/icons/Amenities/Herbario.svg'
import i_herbario2 from './../UI/icons/Amenities/Herbario_white.svg'
import i_cocina from './../UI/icons/Amenities/Cocina Social.svg'
import i_cocina2 from './../UI/icons/Amenities/Cocina Social_white.svg'
import i_billar from './../UI/icons/Amenities/Billar.svg'
import i_billar2 from './../UI/icons/Amenities/Billar_White.svg'
import i_videojuegos from './../UI/icons/Amenities/Salon de videojuegos.svg'
import i_videojuegos2 from './../UI/icons/Amenities/Salon de videojuegos_White.svg'

/*POIS*/
import i_salud from './../UI/icons/POI/Salud.svg'
import i_comercio from './../UI/icons/POI/Comercio.svg'
import i_transporte from './../UI/icons/POI/Transporte2.svg'
import i_otros from './../UI/icons/POI/Otros.svg'
import i_colegios from './../UI/icons/POI/Educacion.svg'
import i_parques from './../UI/icons/POI/Parques.svg'

import i_salud2 from './../UI/icons/POI/Salud2.svg'
import i_comercio2 from './../UI/icons/POI/Comercio2.svg'
import i_transporte2 from './../UI/icons/POI/Transporte2.svg'
import i_otros2 from './../UI/icons/POI/Otros2.svg'
import i_colegios2 from './../UI/icons/POI/Educacion2.svg'
import i_parques2 from './../UI/icons/POI/Parques2.svg'


export default {
    /*Sidebar*/
    'vias': i_vias,
    'vias2': i_vias2,
    'beneficios': i_beneficios,
    'beneficios2': i_beneficios2,
    'amenidades': i_amenidades,
    'amenidades2': i_amenidades2,
    'etapas': i_etapas,
    'etapas2': i_etapas2,
    'vistas': i_vistas2,
    'vistas2': i_vistas,
    'renders': i_renders,
    'recorridos': i_recor,
    'back': i_back,

    /*Amenidades*/
    'Guardería de mascotas': i_guarderia,
    'Guardería de mascotas2': i_guarderia2,
    'Cancha': i_cancha,
    'Cancha2': i_cancha2,
    'Piscinas': i_piscina,
    'Piscinas2': i_piscina2,
    'Pistas de triciclo': i_triciclo,
    'Pistas de triciclo2': i_triciclo2,
    'Juegos infantiles': i_juegosInfantil,
    'Juegos infantiles2': i_juegosInfantil2,
    'Zonas de mascotas al aire libre': i_zonaLibre,
    'Zonas de mascotas al aire libre2': i_zonaLibre2,
    'Parqueadero bicicletas': i_parqueadero,
    'Parqueadero bicicletas2': i_parqueadero2,
    'Salón niños': i_salonNinos,
    'Salón niños2': i_salonNinos2,
    'Salón niñas': i_salonNinas,
    'Salón niñas2': i_salonNinas2,
    'Playground': i_playground,
    'Playground2': i_playground2,
    'Baby Gym': i_babyGym,
    'Baby Gym2': i_babyGym2,
    'Terraza lúdica': i_terraza,
    'Terraza lúdica2': i_terraza2,
    'Cinema': i_cinema,
    'Cinema2': i_cinema2,
    'Salón de yoga o pilates': i_yoga,
    'Salón de yoga o pilates2': i_yoga2,
    'Salón de juegos': i_salonJuegos,
    'Salón de juegos2': i_salonJuegos2,
    'Chimenea': i_chimenea,
    'Chimenea2': i_chimenea2,
    'BBQ': i_bbq,
    'BBQ2': i_bbq2,
    'Taller de cocina o hobbies': i_cocina,
    'Taller de cocina o hobbies2': i_cocina2,
    'Club house': i_club,
    'Club house2': i_club2,
    'Laundry': i_laundry,
    'Laundry2': i_laundry2,
    'Coworking': i_coworking,
    'Coworking2': i_coworking2,
    'Observatorio': i_observatorio,
    'Observatorio2': i_observatorio2,
    'Herbario': i_herbario,
    'Herbario2': i_herbario2,
    'Billar': i_billar,
    'Billar2': i_billar2,
    'Salón de Videojuegos': i_videojuegos,
    'Salón de Videojuegos2': i_videojuegos2,

    /**/
    "Salud": i_salud,
    "Salud2": i_salud2,
    "Comercio": i_comercio,
    "Comercio2": i_comercio2,
    "Transporte": i_transporte,
    "Transporte2": i_transporte2,
    "Otros": i_otros,
    "Otros2": i_otros2,
    "Colegios": i_colegios,
    "Colegios2": i_colegios2,
    "Parques": i_parques,
    "Parques2": i_parques2,
}